import { Outlet, useParams } from "react-router";
import { useFileProcessing } from "@/hooks/use-file-processing";

/**
 * The open draft, keyed on taskId so React fully remounts the stage panes between drafts.
 * It holds the task's stream once for every page it shows: the worker's runs reach the screen
 * only through it, and a page that held its own could forget to.
 */
export function KeyedV2Draft() {
  const { taskId } = useParams<{ taskId: string }>();
  useFileProcessing(taskId ?? null);
  return <Outlet key={taskId} />;
}
